//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "container_leasing_inquiry_detail",
  data(){
    return{
      consultNo: '',
      item:{}
    }
  },
  methods:{
    async getLeasingInquiryDetail () {
      try {
        const params = {
          consultNo: this.consultNo
        }
        const res = await this.$axios.get('/bk/leasingConsult/getDetail', {
          params: params
        });
        if(res.consultNo){
          this.item = res;
        }
        console.log(res)
      } catch (e) {
        console.log(e, 'e')
      }
    },
  },
  created() {
    if(localStorage.getItem('lang')){
      this.$i18n.locale = localStorage.getItem('lang');
    }
    this.consultNo = this.$route.params.consultNo;
    this.getLeasingInquiryDetail();
  },
  computed: {
    currentLang () {
      return this.$i18n.locale
    }
  }
}
